module.exports = __webpack_public_path__ + "img/proapp-1.2b403163.jpg";